import { LightningElement, api, wire } from "lwc";
import { LearningsFragment } from "@devforce/trailhead-client-gql";
import { getLocale } from "@devforce/trailhead-client-locale";
import { gql, QueryAdapter } from "common/graphqlAdapter";
import { LabelsAdapter } from "common/labelsAdapter";
import { showToast } from "tds/toaster";

var data$9 = {
  title: "Zu Trailmix hinzufügen",
  new: "Zu neuem Trailmix hinzufügen",
  add_to_trailmix_success:
    '<a href="%{trailmixUrl}">%{trailmixName}</a> zum Trailmix hinzugefügt.',
  add_to_trailmix_duplicate: "Dieser Inhalt ist bereits im Trailmix verfügbar.",
};
data$9.title;
data$9.add_to_trailmix_success;
data$9.add_to_trailmix_duplicate;

var data$8 = {
  title: "Add to Trailmix",
  new: "Add to new Trailmix",
  add_to_trailmix_success:
    'Added to <a href="%{trailmixUrl}">%{trailmixName}</a> trailmix.',
  add_to_trailmix_duplicate:
    "This content is already available in the trailmix.",
};
data$8.title;
data$8.add_to_trailmix_success;
data$8.add_to_trailmix_duplicate;

var data$7 = {
  title: "Agregar a Trailmix",
  new: "Agregar a nuevo Trailmix",
  add_to_trailmix_success:
    'Se agregó al Trailmix <a href="%{trailmixUrl}">%{trailmixName}</a>.',
  add_to_trailmix_duplicate:
    "Este contenido ya está disponible en el Trailmix.",
};
data$7.title;
data$7.add_to_trailmix_success;
data$7.add_to_trailmix_duplicate;

var data$6 = {
  title: "Agregar a Trailmix",
  new: "Agregar a nuevo Trailmix",
  add_to_trailmix_success:
    'Se agregó al Trailmix <a href="%{trailmixUrl}">%{trailmixName}</a>.',
  add_to_trailmix_duplicate:
    "Este contenido ya está disponible en el trailmix.",
};
data$6.title;
data$6.add_to_trailmix_success;
data$6.add_to_trailmix_duplicate;

var data$5 = {
  title: "Ajouter au Trailmix",
  new: "Ajouter à un nouveau Trailmix",
  add_to_trailmix_success:
    'Ajouté au Trailmix <a href="%{trailmixUrl}">%{trailmixName}</a>.',
  add_to_trailmix_duplicate: "Ce contenu est déjà disponible dans le trailmix.",
};
data$5.title;
data$5.add_to_trailmix_success;
data$5.add_to_trailmix_duplicate;

var data$4 = {
  title: "Aggiungi a Trailmix",
  new: "Aggiungi a un nuovo Trailmix",
  add_to_trailmix_success:
    'Aggiunto al trailmix <a href="%{trailmixUrl}">%{trailmixName}</a>.',
  add_to_trailmix_duplicate: "Questo contenuto è già disponibile nel trailmix.",
};
data$4.title;
data$4.add_to_trailmix_success;
data$4.add_to_trailmix_duplicate;

var data$3 = {
  title: "Trailmix に追加",
  new: "新しい Trailmix に追加",
  add_to_trailmix_success:
    '<a href="%{trailmixUrl}">%{trailmixName}</a> Trailmix に追加されました。',
  add_to_trailmix_duplicate: "このコンテンツはすでに Trailmix に存在します。",
};
data$3.title;
data$3.add_to_trailmix_success;
data$3.add_to_trailmix_duplicate;

var data$2 = {
  title: "Trailmix에 추가",
  new: "새 Trailmix에 추가",
  add_to_trailmix_success:
    '<a href="%{trailmixUrl}">%{trailmixName}</a> Trailmix에 추가되었습니다.',
  add_to_trailmix_duplicate: "이 콘텐츠는 이미 Trailmix에서 사용 가능합니다.",
};
data$2.title;
data$2.add_to_trailmix_success;
data$2.add_to_trailmix_duplicate;

var data$1 = {
  title: "Adicionar a Trailmix",
  new: "Adicionar a nova trailmix",
  add_to_trailmix_success:
    'Adicionado à trailmix <a href="%{trailmixUrl}">%{trailmixName}</a>.',
  add_to_trailmix_duplicate: "Este conteúdo já está disponível na trailmix.",
};
data$1.title;
data$1.add_to_trailmix_success;
data$1.add_to_trailmix_duplicate;

var data = {
  title: "添加到 Trailmix",
  new: "添加到新 Trailmix",
  add_to_trailmix_success:
    '已添加到 <a href="%{trailmixUrl}">%{trailmixName}</a> Trailmix。',
  add_to_trailmix_duplicate: "该内容已存在于 Trailmix 中。",
};
data.title;
data.add_to_trailmix_success;
data.add_to_trailmix_duplicate;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class trailmixAddModal extends LightningElement {
  @api config = null;
  @api open = false;
  @api summary = null;
  selectedTrailmix = null;
  userDetails = null;
  options = null;
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  labels = {};
  get labelOptions() {
    return {
      add_to_trailmix_success: {
        trailmixName: this.selectedTrailmix ? this.selectedTrailmix.label : "",
        trailmixUrl: this.selectedTrailmix ? this.selectedTrailmix.url : "",
      },
    };
  }
  get contentType() {
    switch (this.config.learning.type) {
      case "MODULE":
        return encodeURIComponent("Th::Module");
      case "PROJECT":
        return encodeURIComponent("Th::Project");
      case "TRAIL":
        return encodeURIComponent("Th::Trail");
      default:
        return "";
    }
  }
  get newUrl() {
    if (this.userDetails) {
      const { config, contentType } = this;
      const { learning } = config;
      const username = this.userDetails?.userInfo.trailblazerSlug;
      return `/${getLocale()}/users/${username}/trailmixes/new?contentType=${contentType}&apiName=${
        learning.name
      }`;
    }
    return null;
  }
  get stencils() {
    return [1, 2, 3];
  }
  handleRequestClose() {
    this.dispatchEvent(new CustomEvent("requestclose"));
  }
  handleSelect(trailmix) {
    const trailmixData = {
      uuid: trailmix.id,
    };
    const learningData = {
      uuid: this.summary.id,
      type: this.config.learning.type,
    };
    this.selectedTrailmix = trailmix;
    void this.addToTrailmix(learningData, trailmixData);
  }
  async addToTrailmix(learning, trailmix) {
    let { getClient, gql } = await import("@devforce/trailhead-client-apollo");
    try {
      await getClient().mutate({
        mutation: gql`
          mutation AddToTrailmix(
            $learning: LearningUuidInput!
            $trailmix: TrailmixUuidInput!
          ) {
            addToTrailmix(input: { learning: $learning, trailmix: $trailmix }) {
              __typename
              success
            }
          }
        `,
        variables: {
          learning: learning,
          trailmix: trailmix,
        },
      });
      showToast({
        unsafeMessage: this.labels.add_to_trailmix_success,
        variant: "success",
      });
    } catch {
      showToast({
        message: this.labels.add_to_trailmix_duplicate,
        variant: "error",
      });
    }
  }
  @wire(QueryAdapter, {
    options: "$userQueryOptions",
  })
  onUserResult(result) {
    if (result.error) {
      console.log(result.error);
    } else if (result.errors) {
      console.log(result.errors);
    } else if (result.data) {
      this.userDetails = result.data.getUserProfile;
    }
  }
  get userQueryOptions() {
    return {
      query: gql`
        query UserProfile {
          getUserProfile {
            __typename
            id
            userInfo {
              trailblazerSlug
            }
          }
        }
      `,
    };
  }
  @wire(QueryAdapter, {
    options: "$queryOptions",
  })
  onResult(result) {
    if (result.error) {
      console.log(result.error);
    } else if (result.errors) {
      console.log(result.errors);
    } else if (result.data) {
      this.options = result.data.findTrailmixes.edges
        .map((edge) => edge.node)
        .map((learning) => {
          return {
            handler: () => {
              this.dispatchEvent(
                new CustomEvent("select", {
                  detail: learning,
                })
              );
              this.handleSelect(learning);
            },
            subtitle: learning.label,
            title: learning.label,
          };
        });
    }
  }
  get queryOptions() {
    if (this.userDetails) {
      const { id } = this.userDetails;
      return {
        query,
        variables: {
          creatorId: id,
        },
      };
    }
    return null;
  }
}
const query = gql`
  query FindTrailmixes($first: Int = 29, $after: String, $creatorId: Uuid) {
    findTrailmixes(
      first: $first
      after: $after
      filter: { creatorId: { eq: $creatorId }, crossOrg: { eq: true } }
    ) {
      ...Learnings
    }
  }
  ${LearningsFragment}
`;

export default trailmixAddModal;
export { query };
